export default __webpack_public_path__ + "static/media/landin-blockimg10.848f6025.png";